export function getMonthDates(monthName: string) {
    const months = effectivePeriods();

    const month = months.find(m => m.name === monthName.toUpperCase());
    if (month) {
        return { start: month.start, end: month.end };
    } else {
        return { start: null, end: null };
    }
}

export function effectivePeriods() {
    const currentYear = new Date().getFullYear();
    return [
        { start: `${currentYear}-01-01T00:00`, end: `${currentYear}-01-30T23:59`, name: "JAN" },
        { start: `${currentYear}-01-31T00:00`, end: `${currentYear}-03-01T23:59`, name: "FEB" },
        { start: `${currentYear}-03-02T00:00`, end: `${currentYear}-03-31T23:59`, name: "MAR" },
        { start: `${currentYear}-04-01T00:00`, end: `${currentYear}-05-01T23:59`, name: "APR" },
        { start: `${currentYear}-05-02T00:00`, end: `${currentYear}-06-01T23:59`, name: "MAY" },
        { start: `${currentYear}-06-02T00:00`, end: `${currentYear}-07-01T23:59`, name: "JUN" },
        { start: `${currentYear}-07-02T00:00`, end: `${currentYear}-07-31T23:59`, name: "JUL" },
        { start: `${currentYear}-08-01T00:00`, end: `${currentYear}-08-30T23:59`, name: "AUG" },
        { start: `${currentYear}-08-31T00:00`, end: `${currentYear}-09-30T23:59`, name: "SEP" },
        { start: `${currentYear}-10-01T00:00`, end: `${currentYear}-10-31T23:59`, name: "OCT" },
        { start: `${currentYear}-11-01T00:00`, end: `${currentYear}-12-01T23:59`, name: "NOV" },
        { start: `${currentYear}-12-02T00:00`, end: `${currentYear}-12-31T23:59`, name: "DEC" },
    ];
} 

export function convertAircraftType(aircraftName: string) {
    const aircrafts = aircraftTable3;

    const aircraft = aircrafts.find(a => a.EQ === aircraftName);
    if (aircraft) {
        return { EQ: aircraft.EQ, short: aircraft.short, long: aircraft.long };
    }
    else {
        return { EQ: '00', short: '---', long: 'unknown' }
    }
}

export function aircraftTable() {
    return aircraftTable3;
}

// Active Aircraft Table, not historical
export const aircraftTable1 = [
        /** Boeing */
        // 737
        { EQ: '45', short: 'B737', long: 'B737-800' },
        { EQ: '65', short: 'B737', long: 'B737-800' },
        { EQ: '25', short: 'B737', long: 'B737-MAX' },
        // 777
        { EQ: '83', short: 'B777', long: 'B777-200' },
        { EQ: '82', short: 'B777', long: 'B777-300' },
        // 787
        { EQ: '78', short: 'B787', long: 'B787-8' },
        { EQ: '96', short: 'B787', long: 'B787-9' },
        // A319
        { EQ: '67', short: 'A319', long: 'A319 Basic' },
        { EQ: '92', short: 'A319', long: 'A319' },
        { EQ: '91', short: 'A319', long: 'A319 Sharklet' },
        // A320
        { EQ: '73', short: 'A320', long: 'A320' },
        { EQ: '29', short: 'A320', long: 'A320 Basic' },
        // A321
        { EQ: '77', short: 'A321', long: 'A321 Non-Sharklet' },
        { EQ: '76', short: 'A321', long: 'A321 Sharklet' },
        { EQ: '75', short: 'A321', long: 'A321 Sharklet ETOPS' },
        { EQ: '63', short: 'A321', long: 'A321 Non-Sharklet' },
        { EQ: '26', short: 'A321', long: 'A321NX' },
        { EQ: '80', short: 'A321', long: 'A321-T Sharklet' },
        { EQ: '64', short: 'A321', long: 'A321 Sharklet' },
        { EQ: '42', short: 'A321', long: 'A321NX' },
    
];


// Expanded Aircraft Table with more aircraft types but not verified
export const aircraftTable2 = [
    // Airbus
    //  A300
    { EQ: "171", short: "A300", long: "A300-B1" },
    { EQ: "2", short: "A300", long: "A300-B2" },
    { EQ: "40", short: "A300", long: "A300-B4" },
    { EQ: "AB", short: "A300", long: "A300-600" },
    //  A319
    { EQ: "67", short: "A319", long: "A319 Basic" },
    { EQ: "91", short: "A319", long: "A319 Sharklet" },
    { EQ: "92", short: "A319", long: "A319" },
    //  A320
    { EQ: "73", short: "A320", long: "A320" },
    { EQ: "8X", short: "A320", long: "A320" },
    { EQ: "BX", short: "A320", long: "A320" },
    { EQ: "0F", short: "A320", long: "A320 MOD" },
    { EQ: "70", short: "A320", long: "A320 MOD" },
    { EQ: "29", short: "A320", long: "A320 Basic" },
    //  A321
    { EQ: "76", short: "A321", long: "A321 Sharklet" },
    { EQ: "77", short: "A321", long: "A321 Non-Sharklet" },
    { EQ: "80", short: "A321", long: "A321-T Sharklet" },
    { EQ: "75", short: "A321", long: "A321 Sharklet ETOPS" },
    { EQ: "63", short: "A321", long: "A321 Non-Sharklet" },
    { EQ: "26", short: "A321", long: "A321NX" },
    { EQ: "64", short: "A321", long: "A321 Sharklet" },
    { EQ: "42", short: "A321", long: "A321NX" },
    { EQ: "24", short: "A321", long: "A321NA Neo" },
    //  A330
    { EQ: "43", short: "330", long: "A330-200" },
    { EQ: "98", short: "330", long: "A330-300" },
    //Boeing
    //  B717
    { EQ: "71T", short: "B717", long: "B717-200T" },
    { EQ: "EC", short: "B717", long: "B717-200" },
    //  B727
    { EQ: "3", short: "B727", long: "B727-100" },
    { EQ: "95", short: "B727", long: "B727-200" },
    { EQ: "96", short: "B727", long: "B727-200 Advanced" },
    //  B737
    { EQ: "4", short: "B737", long: "B737-200" },
    { EQ: "B8", short: "B737", long: "B737-800" },
    { EQ: "B9", short: "B737", long: "B737-900" },
    { EQ: "CE", short: "B737", long: "B737 Classic/NG" },
    { EQ: '45', short: 'B737', long: 'B737-800' },
    { EQ: '65', short: 'B737', long: 'B737-800' },
    { EQ: '25', short: 'B737', long: 'B737-MAX' },
    //  B757
    { EQ: "58", short: "B757", long: "B757-200" },
    { EQ: "61", short: "B757", long: "B757-200" },
    { EQ: "62", short: "B757", long: "B757-200" },
    { EQ: "B0", short: "B757", long: "B757-200" },
    { EQ: "ED", short: "B757", long: "B757-200" },
    { EQ: "26", short: "B757", long: "B757-200" },
    { EQ: "B1", short: "B757", long: "B757-300" },
    { EQ: "49", short: "B757", long: "B757-300" },
    { EQ: "BA", short: "B757", long: "B757-300" },
    //  B767
    { EQ: "23", short: "B767", long: "B767-200" },
    { EQ: "5", short: "B767", long: "B767-200" },
    { EQ: "27", short: "B767", long: "B767-300" },
    { EQ: "34", short: "B767", long: "B767-300" },
    { EQ: "76T", short: "B767", long: "B767-300ER" },
    { EQ: "B6", short: "B767", long: "B767-300ER" },
    { EQ: "B7", short: "B767", long: "B767-300ER" },
    { EQ: "D0", short: "B767", long: "B767-300ER" },
    { EQ: "D7", short: "B767", long: "B767-300ER" },
    { EQ: "EE", short: "B767", long: "B767-400ER" },
    { EQ: "EG", short: "B767", long: "B767-400ER" },
    { EQ: "ZA", short: "B76T", long: "B767-400ER" },
    //  B777
    { EQ: "6", short: "B777", long: "B777-200" },
    { EQ: "82", short: "B777", long: "B777-200ER" },
    { EQ: "83", short: "B777", long: "B777-200LR" },
    { EQ: "A3", short: "B777", long: "B777-300" },
    { EQ: "AE", short: "B777", long: "B777-300ER" },
    { EQ: "AF", short: "B777", long: "B777-300ER" },
    { EQ: "AF0", short: "B777", long: "B777-Freighter" },
    //  B787
    { EQ: "78", short: "B787", long: "B787-8" },
    { EQ: '96', short: 'B787', long: 'B787-9' },
    // Douglas
    { EQ: "15", short: "D10", long: "DC10-10" },
    { EQ: "97", short: "D10", long: "DC10-10F" },
    { EQ: "31", short: "D10", long: "DC10-15" },
    { EQ: "24", short: "D10", long: "DC10-30" },
    { EQ: "25", short: "D10", long: "DC10-30F" },
    { EQ: "28", short: "D10", long: "DC10-40" },
    { EQ: "29", short: "D10", long: "DC10-40F" },
    { EQ: "30", short: "D10", long: "DC10-30ER" },
    // Embraer
    { EQ: "04", short: "190", long: "E190 E-Jet" },
    // Fokker
    { EQ: "0A", short: "F100", long: "F100 Basic" },
    { EQ: "0A0", short: "F100", long: "F100 MOD" },
    { EQ: "1", short: "F100", long: "F100 Standard" },
    { EQ: "100", short: "F100", long: "F100 Early PROD" },
    { EQ: "18", short: "F100", long: "F100 MOD" },
    { EQ: "56", short: "F100", long: "F100 Special" },
    { EQ: "A0A", short: "F100", long: "F100 Special" },
    { EQ: "X", short: "F100", long: "F100 EXPMTL" },
    // McDonnell Douglas
    //  MD-11
    { EQ: "17", short: "D11", long: "MD11" },
    { EQ: "51", short: "D11", long: "MD11 Stretch" },
    { EQ: "54", short: "D11", long: "MD11 Engine MOD" },
    { EQ: "7", short: "D11", long: "MD11-ER" },
    //  MD-80
    { EQ: "AA", short: "S80", long: "MD-80 General" },
    { EQ: "EF", short: "S80", long: "MD-80" },
    { EQ: "F0", short: "S80", long: "MD-80 Trainer" },
    { EQ: "F1", short: "S80", long: "MD-80 Trainer MOD" },
    { EQ: "F2", short: "S80", long: "MD-80 MOD" },
    { EQ: "ZZ", short: "S8T", long: "MD-80 Mixed/MOD" },
    { EQ: "175", short: "S80", long: "MD-80" },
    { EQ: "A7", short: "R80", long: "MD-80T Special" },
    { EQ: "A8", short: "R80", long: "MD-80 MOD" },
    { EQ: "8", short: "S80", long: "MD-81" },
    { EQ: "8D", short: "S80", long: "MD-81 MOD" },
    { EQ: "10", short: "S80", long: "MD-82" },
    { EQ: "9", short: "S80", long: "MD-82" },
    { EQ: "22", short: "S80", long: "MD-83LR" },
    { EQ: "32", short: "S80", long: "MD-83LR MOD" },
    { EQ: "33", short: "S80", long: "MD-83LR MOD" },
    { EQ: "50", short: "S80", long: "MD-87 Short" },
    { EQ: "52", short: "S80", long: "MD-87 Short MOD" },
    { EQ: "35", short: "S80", long: "MD-88" },
    { EQ: "36", short: "S80", long: "MD-88 MOD" },
    { EQ: "37", short: "S80", long: "MD-88 MOD" },
    { EQ: "A6", short: "S80", long: "MD-88 MOD" },
    { EQ: "A9", short: "R90", long: "MD-90" },
];

/** Aircraft List provided by CA Curtis DeKeyrel empNum: 604385
 * January 9, 2025
 */
export const aircraftTable3 = [
    //Embraer
    { EQ: "4", short: "190", long: "E190 E-Jet" },
    //Airbus
    { EQ: "43", short: "330", long: "A330-200" },
    { EQ: "98", short: "330", long: "A330-300" },
    { EQ: "40", short: "A300", long: "A300-B1" },
    { EQ: "AB", short: "A300", long: "A300-600" },
    { EQ: "67", short: "A319", long: "A319 Basic" },
    { EQ: "91", short: "A319", long: "A319 Sharklet" },
    { EQ: "92", short: "A319", long: "A319" },
    { EQ: "73", short: "A320", long: "A320" },
    { EQ: "29", short: "A320", long: "A320 Basic" },
    { EQ: "76", short: "A321", long: "A321 Sharklet" },
    { EQ: "77", short: "A321", long: "A321 Non-Sharklet" },
    { EQ: "80", short: "A321", long: "A321-T Sharklet" },
    { EQ: "75", short: "A321", long: "A321 Sharklet ETOPS" },
    { EQ: "63", short: "A321", long: "A321 Non-Sharklet" },
    { EQ: "26", short: "A321", long: "A321NX" },
    { EQ: "64", short: "A321", long: "A321 Sharklet" },
    { EQ: "24", short: "A321", long: "A321NA" },
    //Boeing
    { EQ: "EC", short: "B717", long: "B717-200" },
    { EQ: "96", short: "B727", long: "B727-200 Advanced" },
    { EQ: "92", short: "B727", long: "B727-200" },
    { EQ: "98", short: "B727", long: "B727-200" },
    { EQ: "B8", short: "B737", long: "B737-800" },
    { EQ: "B9", short: "B737", long: "B737-900" },
    { EQ: "CE", short: "B737", long: "B737 Classic/NG" },
    { EQ: "45", short: "B737", long: "B737-800" },
    { EQ: "65", short: "B737", long: "B737-800" },
    { EQ: "25", short: "B737", long: "B737-MAX" },
    { EQ: "58", short: "B757", long: "B757-200" },
    { EQ: "61", short: "B757", long: "B757-200" },
    { EQ: "62", short: "B757", long: "B757-200" },
    { EQ: "B0", short: "B757", long: "B757-200" },
    { EQ: "39", short: "B757", long: "B757-200" },
    { EQ: "26", short: "B757", long: "B757-200" },
    { EQ: "B1", short: "B757", long: "B757-300" },
    { EQ: "49", short: "B757", long: "B757-300" },
    { EQ: "BA", short: "B757", long: "B757-300" },
    { EQ: "23", short: "B767", long: "B767-200" },
    { EQ: "27", short: "B767", long: "B767-300" },
    { EQ: "34", short: "B767", long: "B767-300" },
    { EQ: "B6", short: "B767", long: "B767-300ER" },
    { EQ: "B7", short: "B767", long: "B767-300ER" },
    { EQ: "D0", short: "B767", long: "B767-300ER" },
    { EQ: "D7", short: "B767", long: "B767-300ER" },
    { EQ: "28", short: "B767", long: "B767T" },
    { EQ: "D1", short: "B767", long: "B767-300" },
    { EQ: "B2", short: "B767", long: "B767-200" },
    { EQ: "82", short: "B777", long: "B777-200ER" },
    { EQ: "83", short: "B777", long: "B777-200LR" },
    { EQ: "AE", short: "B777", long: "B777-300ER" },
    { EQ: "AF", short: "B777", long: "B777-300ER" },
    { EQ: "78", short: "B787", long: "B787-8" },
    { EQ: "96", short: "B787", long: "B787-9" },
    //Douglas
    { EQ: "31", short: "D10", long: "DC10-15" },
    { EQ: "24", short: "D10", long: "DC10-30" },
    { EQ: "29", short: "D10", long: "DC10-40F" },
    { EQ: "17", short: "D11", long: "MD11" },
    { EQ: "51", short: "D11", long: "MD11 Stretch" },
    { EQ: "54", short: "D11", long: "MD11 Engine MOD" },
    //Fokker
    { EQ: "0A", short: "F100", long: "F100 Basic" },
    { EQ: "18", short: "F100", long: "F100 MOD" },
    { EQ: "56", short: "F100", long: "F100 Special" },
    //McDonnell Douglas
    { EQ: "8C", short: "S80", long: "MD-80" },
    { EQ: "5A", short: "S80", long: "MD-80" },
    { EQ: "EF", short: "S80", long: "MD-80" },
    { EQ: "F0", short: "S80", long: "MD-80 Trainer" },
    { EQ: "F1", short: "S80", long: "MD-80 Trainer MOD" },
    { EQ: "F2", short: "S80", long: "MD-80 MOD" },
    { EQ: "A8", short: "S80", long: "MD-81" },
    { EQ: "8D", short: "S80", long: "MD-81 MOD" },
    { EQ: "A9", short: "S80", long: "MD-82" },
    { EQ: "22", short: "S80", long: "MD-83LR" },
    { EQ: "32", short: "S80", long: "MD-83LR MOD" },
    { EQ: "33", short: "S80", long: "MD-83LR MOD" },
    { EQ: "50", short: "S80", long: "MD-87 Short" },
    { EQ: "52", short: "S80", long: "MD-87 Short MOD" },
    { EQ: "35", short: "S80", long: "MD-88" },
    { EQ: "36", short: "S80", long: "MD-88 MOD" },
    { EQ: "37", short: "S80", long: "MD-88 MOD" },
    { EQ: "A6", short: "S80", long: "MD-88 MOD" },
    { EQ: "A7", short: "S80", long: "MD-80" },
    { EQ: "AA", short: "S80", long: "MD-80" },
    { EQ: "ZZ", short: "S8T", long: "MD-80 Mixed/MOD" }
];

